module.exports = __webpack_public_path__ + "static/media/docs.156c8583.svg";